module.exports = __webpack_public_path__ + "static/media/anchor-bonding.e9307279.png";